import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogModule } from '@angular/material/dialog';
import { TpaSearchCoverageResExtended } from 'src/app/features/tpa/models/http/tpa-http.model';
import { MatRadioGroup } from "@angular/material/radio";
import { CommonModule } from '@angular/common';
import { TpaPerson } from 'src/app/features/tpa/models/tpa-person.model';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { PersonSelectionItemComponent } from "../person-selection-item/person-selection-item.component";

@Component({
  selector: 'app-person-selection-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatDialogContent, MatDialogActions, MatRadioGroup, PersonSelectionItemComponent],
  templateUrl: './person-selection-modal.component.html',
  styleUrl: './person-selection-modal.component.scss'
})
export class PersonSelectionModalComponent {
  persons: TpaPerson[] = [];
  selectedPerson: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<PersonSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TpaSearchCoverageResExtended[]
  ) {
    for (const item of data) {
      if (!this.persons.some(person => person.personId === item.personId)) {
        this.persons.push({
          personId: item.personId,
          insuredFullName: item.insuredFullName,
          insuredDateOfBirth: item.dateOfBirth || '',
          memberIds: item.memberId ? [item.memberId] : [],
          externalIds: item.externalId ? [item.externalId] : [],
          insuredCitizenship: item.censusCitizenship || '',
        });
      }
      else {
        const existingPerson = this.persons.find(person => person.personId === item.personId);
        if (existingPerson) {
          if (item.memberId && !existingPerson.memberIds?.includes(item.memberId)) {
            existingPerson.memberIds?.push(item.memberId);
          }
          if (item.externalId && !existingPerson.externalIds?.includes(item.externalId)) {
            existingPerson.externalIds?.push(item.externalId);
          }
          if (!existingPerson.insuredCitizenship) {
            existingPerson.insuredCitizenship = item.censusCitizenship || '';
          }
          else if (item.censusCitizenship && !existingPerson.insuredCitizenship.includes(item.censusCitizenship)) {
            existingPerson.insuredCitizenship += `, ${item.censusCitizenship}`;
          }
        }
      }
    }
  }

  onSelect(personId: string): void {
    this.selectedPerson = personId;
  }
}
